import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL Konfigürasyonu
 * Azure Portal'dan App Registration bilgilerini buraya girin
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '<your-client-id>',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || '<your-tenant-id>'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * API Scopes
 * Microsoft Graph API erişimi için gerekli izinler
 */
export const loginRequest = {
  scopes: [
    'User.Read',
    'Calendars.Read',
    'OnlineMeetings.Read',
    'OnlineMeetingTranscript.Read.All',
    'Sites.ReadWrite.All',  // SharePoint için
  ],
};

/**
 * Graph API scope'ları
 */
export const graphScopes = {
  user: ['User.Read'],
  calendar: ['Calendars.Read'],
  meetings: ['OnlineMeetings.Read'],
  transcripts: ['OnlineMeetingTranscript.Read.All'],
};

/**
 * API Endpoints
 */
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
};
